import { CardProps } from '../../components/Card/card.types'
import {
  IItemsStatisticsDTO,
  IOrderInvoiceTraceabilityStatistics,
  ItemRawStatisticsDataDTO,
  OrderInvoiceRawStatisticsDataDTO,
} from '../../sdk/traceability/traceability.types'
import { hexaColors } from '../../utilities/colors'

const getProvidersCardsProps = (
  statistics: IItemsStatisticsDTO,
  statisticsData?: ItemRawStatisticsDataDTO,
): CardProps[] => {
  return Object.keys(statistics)
    .filter((key) => statistics[key].parent === 'providersQuantitySum')
    .sort((a, b) => statistics[a].order - statistics[b].order)
    .map((key: string, index: number) => {
      const item = statistics[key]
      const propKey = key.split('QuantitySum')[0]

      return {
        title: item.title,
        icon: 'building3',
        color: hexaColors[index % hexaColors.length],
        value: `${item?.value ?? 0}`,
        seeMore: statisticsData?.companiesBySegments?.[propKey]?.map(
          (company) => `${company.name}`,
        ),
      }
    })
}

export const getInvoiceCardProps = (
  invoiceStatistics?: IOrderInvoiceTraceabilityStatistics,
  invoiceStatisticsData?: OrderInvoiceRawStatisticsDataDTO,
) => {
  if (!invoiceStatistics) return []

  const cards: CardProps[] = []

  cards.push(
    {
      title: 'Total de SKUs',
      icon: 'barcode',
      color: hexaColors[3],
      value: `${invoiceStatistics.finishedItemsCodeQuantitySum?.value ?? 0}`,
      seeMore: invoiceStatisticsData?.finishedItemsCodes,
    },
    {
      title: 'Total de Ordens de Compra',
      icon: 'newspaper',
      color: hexaColors[6],
      value: `${invoiceStatistics.ordersQuantitySum?.value ?? 0}`,
      seeMore: invoiceStatisticsData?.ordersCodes,
    },
  )

  const providersCards = getProvidersCardsProps(
    invoiceStatistics,
    invoiceStatisticsData,
  )

  cards.push(...providersCards.filter((card) => card.value !== '0'))

  return cards
}

export const getItemCardProps = (
  itemStatistics?: IItemsStatisticsDTO,
  itemStatisticsData?: ItemRawStatisticsDataDTO,
) => {
  if (!itemStatistics) return []

  const cards: CardProps[] = []

  cards.push({
    title: 'Total de Materiais',
    icon: 'stack',
    color: hexaColors[6],
    value: `${itemStatistics.feedstockItemsCodeQuantitySum?.value ?? 0}`,
    seeMore: itemStatisticsData?.feedstockItemsCodes,
  })

  const providersCards = getProvidersCardsProps(
    itemStatistics,
    itemStatisticsData,
  )

  cards.push(...providersCards.filter((card) => card.value !== '0'))

  return cards
}

export const getOrderCardProps = (
  itemStatistics?: IItemsStatisticsDTO,
  itemStatisticsData?: ItemRawStatisticsDataDTO,
) => {
  if (!itemStatistics) return []

  const cards: CardProps[] = []

  cards.push({
    title: 'Total de SKUs',
    icon: 'barcode',
    color: hexaColors[6],
    value: `${itemStatistics.finishedItemsCodeQuantitySum?.value ?? 0}`,
    seeMore: itemStatisticsData?.finishedItemsCodes,
  })

  const providersCards = getProvidersCardsProps(
    itemStatistics,
    itemStatisticsData,
  )

  cards.push(...providersCards.filter((card) => card.value !== '0'))

  return cards
}
